import h, { FunctionComponent } from 'preact';
import { OrderType } from './index';

const OrderTypes: FunctionComponent<OrderTypesProps> = ({ selectedOrderType, orderTypes, canChange, onChange, selectId }) => {
  let orderTypeOptions =[<option disabled={true} selected={true}>No order types found</option>];

  if (orderTypes.length > 0) {
    orderTypeOptions = orderTypes.filter(ot => ot.visible && ot.due_date !== null).map(ot => (
      <option value={ot.alias}>{ot.name}</option>
    ));
  }

  return <div class="d-flex col-12 col-md-6 col-lg-5 p-0 mb-3 mb-lg-0 pr-md-4 mt-0 justify-content-end align-items-center font-weight-bold">
            <label class="col-5" htmlFor={ selectId ?? 'checkout-forwardordering' }>
                Place order as: (<a href="https://oneandall.co.uk/forward-orders" target="_blank" rel="noopener">?</a>)
            </label>
            <select
                name="orderType"
                id={ selectId ?? 'checkout-forwardordering' }
                class="form-control custom-select col-7 h-100"
                disabled={!canChange}
                defaultValue={selectedOrderType === null ? '' : selectedOrderType}
                onChange={e => {
                    const v = (e.target as HTMLSelectElement).value;
                    onChange(v === '' ? null : v);
                }}
            >
              {orderTypeOptions}
            </select>
        </div>
    ;
};

interface OrderTypesProps {
    selectedOrderType: string | null;
    orderTypes: Array<OrderType>;
    canChange: boolean;
    onChange: (alias: string | null) => void;
    selectId: string | null;
}

export default OrderTypes;
